import { CheckCircleFilled } from '@ant-design/icons';
import { Button, Divider, Flex, Progress, Typography } from 'antd';
import type { EvidenceProgress } from 'api/brokerCases/types';
import { getProgressPercent } from 'pages/EvidencePage/helpers';

export interface INextStepsProps {
  progress: EvidenceProgress;
  onGoToEvidenceV2?: () => void;
}

export const NextSteps = ({ progress, onGoToEvidenceV2 }: INextStepsProps) => {
  const { totalCount, completedCount } = progress;
  const percent = getProgressPercent(completedCount, totalCount);

  return (
    <div className='w-full rounded-2xl bg-white'>
      <div className='px-6 py-3'>
        <Typography.Text className='mb-0 text-lg font-bold leading-8'>My next steps</Typography.Text>
      </div>
      <Divider className='my-0' />
      <div className='p-6'>
        <Flex className='gap-5 border-2 border-dashed border-slate-200 p-6 rounded-2xl'>
          {totalCount !== completedCount ? (
            <>
              <div className='relative h-20 w-20 shrink-0'>
                <Progress type='circle' percent={percent} size={80} format={() => null} strokeColor='#05DF72' />
                <div className='absolute inset-0 flex items-center justify-center'>
                  <Typography.Text className='text-center text-base font-bold leading-6'>
                    {completedCount} of {totalCount}
                  </Typography.Text>
                </div>
              </div>
              <Flex vertical className='gap-1'>
                <Typography.Text className='text-lg font-bold leading-8'>Upload customer evidence</Typography.Text>
                <Typography.Text className='text-sm font-normal leading-5 text-gray-500'>
                  There’s evidence needed for this application to progress{' '}
                </Typography.Text>
                <Button
                  type='default'
                  className='mt-3 h-8 w-32 rounded-3xl border border-gray-200 bg-white px-4 text-sm font-normal leading-5 text-black shadow-none'
                  onClick={onGoToEvidenceV2}
                >
                  Go to Evidence
                </Button>
              </Flex>
            </>
          ) : (
            <Flex align='center' className='gap-3'>
              <CheckCircleFilled className='text-[40px] leading-none text-green-500' />
              <Typography.Text className='text-base ml-1 font-semibold leading-8'>
                Customer evidence completed
              </Typography.Text>
            </Flex>
          )}
        </Flex>
        {totalCount === completedCount && (
          <div className='ant-flex ant-flex-align-center ant-flex-justify-space-between mt-4 text-center bg-[#F3F4F6] p-4 rounded-lg'>
            <Typography.Text className='ant-typography text-sm font-normal leading-5 text-gray-400 text-center'>
              There&apos;s nothing else to do for you right now.
            </Typography.Text>
          </div>
        )}
      </div>
    </div>
  );
};
